import React from "react";

function ArrowUp({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6641 6.23828L15.9766 11.5508C16.3438 11.918 16.3438 12.5117 15.9766 12.875L15.0938 13.7578C14.7266 14.125 14.1328 14.125 13.7695 13.7578L10.0039 9.99219L6.23828 13.7578C5.87109 14.125 5.27734 14.125 4.91406 13.7578L4.03125 12.875C3.66406 12.5078 3.66406 11.9141 4.03125 11.5508L9.34375 6.23828C9.70312 5.87109 10.2969 5.87109 10.6641 6.23828Z"
        fill={color}
      />
    </svg>
  );
}

export default ArrowUp;
